<div  id="currentAccountWidget" class="p10 app-white-card">
  <div class="col-md-8 wc-right-div">
    <h4>{{account.accountDescription}}</h4>
    <h2 class="no-bottom-margin">{{account.balance|number:2}} {{account.currencySymbol}}</h2>
    <p>{{account.availableBalance|number:2}} {{account.currencySymbol}} available</p>
  </div>
  <div class="col-md-4 wc-left-div">
    <div class="wc-left-div-wrapper">
      <button id="dykBtn" type="input" style="width:100%;" class="btn btn-default app-btn-blue" data-ng-click="dashboard.gotoAccount(account.accountId)">View account</button>
    </div>
  </div>
</div>
